import { useCallback, useEffect } from 'react';
import { loadBusinessByIdAsync } from '../../data-layer/business/actions';
import { selectBusinessById } from '../../data-layer/business/selectors';
import { useDispatch } from '../../data-layer/useDispatch';
import { useSelector } from '../../data-layer/useSelector';
import type { BusinessModel } from '../../data-layer/business/types';

interface UseBusinessProps {
    businessId: string;
}

export const useBusinessModel = (props: UseBusinessProps): BusinessModel | undefined => {
    const { businessId } = props;
    const dispatch = useDispatch();
    const businessModel = useSelector((state) => selectBusinessById(state, businessId));
    const onLoadBusiness = useCallback(
        () => dispatch(loadBusinessByIdAsync(businessId)),
        [dispatch, businessId],
    );

    useEffect(() => {
        if (businessId && (!businessModel || businessModel.__type === 'lite')) {
            onLoadBusiness();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [businessId, businessModel]);

    return businessModel;
};
